import { Component, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { DidConfigService, t_DidConfig } from 'src/app/services/apiHandler/did-config/did-config.service';
import { t_DataIdentifier } from 'src/app/services/apiHandler/did-data-retrieval/did-data-retrieval.service'; 
import { GatewayConnectionService } from 'src/app/services/apiHandler/gateway-connection/gateway-connection.service';
import { GlobalService } from 'src/app/services/helper/global-helper';
import { RoleService } from 'src/app/services/helper/role-handling-helper';


@Component({
  selector: 'app-did-data',
  templateUrl: './did-data.component.html',
  styleUrls: ['./did-data.component.scss']
})
export class DidDataComponent implements OnInit, OnDestroy {

  public didMapping: t_DidConfig = [];
  public didList: t_DataIdentifier[] = [];
  public checked: boolean = false;
  public checkCheckStatus: Subscription = new Subscription;
  public writeChecked: boolean = false;
  public fetched: boolean = false;

  machinenumber: string = "";
  line: string = '';
  previousUrl: string = '';
  locked: boolean = false;
  savedParameters: t_DataIdentifier[] = [];

  constructor(public didService: DidConfigService, private gatewayConnectionService: GatewayConnectionService, public roleService: RoleService, private global: GlobalService){
    this.global.machineNumber.subscribe({
      next: newValue => {this.machinenumber = newValue.number;}
    });
    this.global.previousUrl$.subscribe((previousUrl: string) => {
      this.previousUrl = previousUrl;      
    });
    this.global.savedParameters.subscribe({
      next: newValue => {
        this.locked = newValue.locked; 
        this.savedParameters = newValue.parameters;
      }
    });
    this.global.machineInfos.subscribe({
      next: newValue => {this.line = newValue.line;}
    });
  }

  ngOnInit(): void {
    this.checkPreviousUrl().then(() => {
      this.setupServices().then(() => {
        this.checkCheckStatus = interval(1000).subscribe(() => {
          this.didService.getDidQueryList().subscribe((resp) => {
            this.didList = JSON.parse(JSON.stringify(resp.body));
            if(this.didList.length == 0){
              this.checked = false;
            } else {
              this.checked = true;
            }
            this.writeChecked = false;
            this.didList.forEach((item) => {
              let element = this.didMapping[0].ecu_dids.find(ele => ele.did == item.data_id);
              if(element?.readWrite == "ReadWrite") {
                this.writeChecked = true;
              }
            });
          });
        });
      });
    }); 
  }

  ngOnDestroy(): void {
    this.checkCheckStatus.unsubscribe();
    this.locked = true;
    if(this.locked) {
      this.global.savedParameters.next({locked: this.locked, parameters: this.didList});
    }
  }

  private setupServices(): Promise<void> {
    return new Promise((resolve) => {
      this.didService.getEcuDidMappingByMachineNumber(this.machinenumber, this.line).subscribe({
        next: (response: t_DidConfig) => {
          this.didMapping = this.didMapping.concat(response);
          this.fetched = true;
          resolve();
        },
      });
    });
  }

  // remove dids from list when coming from other page than dataDisplay
  private checkPreviousUrl(): Promise<void> {
    return new Promise((resolve) => {
      if(!this.previousUrl.includes('dataDisplay')) {
        if(this.locked) {
          /*this.didService.getDidQueryList().subscribe((resp) => {
            this.didList = JSON.parse(JSON.stringify(resp.body));
            if(this.didList.length > 0){
              this.clearList().then(() => {
                this.addSavedParameters();
              });
            } else {
              this.addSavedParameters();
            }
          });
          resolve();*/
          this.clearList().then(() => {
            this.addSavedParameters();
            resolve();
          });
        } else {
          this.didService.getDidQueryList().subscribe((resp) => {
            this.didList = JSON.parse(JSON.stringify(resp.body));
            if(this.didList.length > 0){
              this.clearList();
            }
          });
          resolve();
        }
      } else {
        resolve();
      }
    });
  }

  public clearList(): Promise<void> {
    return new Promise((resolve) => {
      this.gatewayConnectionService.checkGatewayAlive().subscribe({
        next: (isAlive) => {
            if(isAlive){
              this.didList.forEach(data => {
                this.didService.removeDidFromQueryList({ecu_id: data.ecu_id, data_id: data.data_id}).subscribe();
              });
            }
            resolve();
        }
      });
    });
  }

  public addSavedParameters() {
    this.gatewayConnectionService.checkGatewayAlive().subscribe({
      next: (isAlive) => {
          if(isAlive){
            this.savedParameters.forEach(data => {
              this.didService.addDidToQueryList({ecu_id: data.ecu_id, data_id: data.data_id}).subscribe();
            });
          }
        }
      });
  }

  public deleteSelection() {
    this.didService.setClearList();
    this.locked = false;
      if(!this.locked) {
        this.global.savedParameters.next({locked: this.locked, parameters: []});
      }
  }
}
